import { ApiClient } from './client.js'
import { ME, TEAMS } from './resources.js'

const client = new ApiClient()

export default {
  me () {
    return client.get(`${ME}`)
  },

  options () {
    return client.options(`${TEAMS}register/`)
  },

  register (data) {
    return client.post(`${TEAMS}register/`, data)
  },

  partialUpdate (data) {
    return client.patch(`${ME}`, data)
  }
}
